// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_shared_sentry_ts":"70654872a7e601e7","src_app_search_search_module_ts":"2b9d8b591ffa9856","src_app_library-list_library-list_module_ts":"70c0f7c9a78fd241","src_app_search_full-card_full-card_module_ts":"8b83fca46320aa3c"}[chunkId] + ".js";
};